import {getGlobalStore} from "../state/globalStore"

const axiosPromise = import(/* webpackChunkName: "axios" */ 'axios')

class LoggerClass {
  async log(msg) {
    let networkType
    const store = getGlobalStore()
    if (store) {
      networkType = 'lalb'
    }

    const msgObj = {
      text: (typeof msg === "string") ? msg : JSON.stringify(msg),
      networkType: networkType,
    }

    try {
      const axios = (await axiosPromise).default
      await axios.post('/api/logger/log-js-user-event', JSON.stringify(msgObj))
      console.log(`Logged message '${msg}' to server.`)
    } catch (err) {
      console.log(`Failed to log message '${msg}' to server. ${err}`)
    }
  }
}

export const Logger = new LoggerClass()